import classNames from 'classnames'
import moment from 'moment'
import { useState } from 'react'

import { EIcons } from '@/app/types/iconType'
import { type ILog } from '@/app/types/settingsTypes'
import { Icon } from '@/shared'

import style from './Logs.module.scss'

interface IProps {
    logs: ILog[]
}

export const Logs = (props: IProps) => {
    const { logs } = props
    const [isOpened, setIsOpened] = useState<boolean>(false)

    const onHandleOpenLogs = () => setIsOpened((prev) => !prev)

    return (
        <div className={style.container}>
            <div className={style.titleWrapper} onClick={onHandleOpenLogs}>
                <div className={style.title}>
                    <span>Операции записи</span>
                </div>
                <div className={style.iconBtn}>
                    <Icon iconName={EIcons.AROW} color='#161F29' />
                </div>
            </div>
            <div className={classNames(style.content, !isOpened && style.visibleContent)}>
                {logs.map((log, idx) => {
                    const { logCreateAt, logMessage } = log
                    return (
                        <div key={idx} className={style.item}>
                            <span className={style.date}>{moment(logCreateAt).format('DD.MM.YYYY HH:mm')}</span>
                            <span className={style.msg}>{logMessage}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
